export default __webpack_public_path__ + "static/media/252.59d822b8.jpg";